import React, { FC } from "react";

const PhotoPlaceholder: FC<{ width: string; height: string }> = ({
  width,
  height,
}) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/images/photo-placeholder.png`}
      alt="placeholder"
      style={{ width: width, height: height, objectFit: "cover", borderRadius: "4px" }}
    />
  );
};

export default PhotoPlaceholder;
